export default "__VITE_ASSET__Bpzv6$gG__"